/** @deprecated Use enum in StoreData.ts */
export const storeTypes = {
    Traditional: 'Traditional',
    XF: 'CrossFunctional',
    CBC: 'CarBuyingCenter'
};
